import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import {
  SnackbarKey,
  SnackbarProvider as SnackbarProviderNS,
  SnackbarProviderProps as SnackbarProviderPropsNS,
  closeSnackbar,
} from 'notistack';
import { ReactNode, useMemo } from 'react';

type SnackbarProviderProps = {
  children: ReactNode;
};

export const SnackbarProvider = ({ children }: SnackbarProviderProps) => {
  const providerProps: SnackbarProviderPropsNS = useMemo(
    () => ({
      anchorOrigin: {
        horizontal: 'left',
        vertical: 'bottom',
      },
      autoHideDuration: 6000,
      maxSnack: 6,
      action: (snackbarKey: SnackbarKey) => (
        <IconButton onClick={() => closeSnackbar(snackbarKey)}>
          <CloseIcon color="inherit" />
        </IconButton>
      ),
    }),
    []
  );

  return <SnackbarProviderNS {...providerProps}>{children}</SnackbarProviderNS>;
};
